// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_footer_rights = /** @type {(inputs: {}) => string} */ () => {
	return `All rights reserved.`
};

const el_footer_rights = /** @type {(inputs: {}) => string} */ () => {
	return `Με επιφύλαξη παντός δικαιώματος.`
};

const ru_footer_rights = /** @type {(inputs: {}) => string} */ () => {
	return `Все права защищены.`
};

const he_footer_rights = /** @type {(inputs: {}) => string} */ () => {
	return `כל הזכויות שמורות.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer_rights = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_rights(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_rights", locale)
	if (locale === "en") return en_footer_rights(inputs)
	if (locale === "el") return el_footer_rights(inputs)
	if (locale === "ru") return ru_footer_rights(inputs)
	if (locale === "he") return he_footer_rights(inputs)
	return "footer_rights"
};